export default __webpack_public_path__ + "static/media/info_circle.a69278dc.svg";